import * as Sentry from '@sentry/react';
import { useRouter } from '@tanstack/react-router';
import type { SchemaLoanRequestResolver_Find } from 'cpool-tables/backend-resolvers';

import { TableColumnAdviserAssign } from '~/features/leadList/components/Table/columns/AdviserAssign';
import { ContactInfo } from '~/features/leadList/components/Table/columns/ContactInfo';
import { LeadInfo } from '~/features/leadList/components/Table/columns/LeadInfo';
import { LeadTraitInfo } from '~/features/leadList/components/Table/columns/LeadTraitInfo';
import { StatusInfo } from '~/features/leadList/components/Table/columns/StatusInfo';
import { cn } from '~/utils/cnTailwind.ts';

type Props = {
    lead: SchemaLoanRequestResolver_Find[number];
    brightness?: 'dark' | 'light';
};

export const SearchResult: React.FC<Props> = ({ brightness, lead }) => {
    const router = useRouter();
    if (lead.antragsteller1 === null || lead.antragsteller1 === undefined) {
        return null;
    }

    const safeLeadData = {
        ...lead,
        antragsteller1: lead.antragsteller1 as NonNullable<typeof lead.antragsteller1>,
    };

    const preload = async () => {
        router
            .preloadRoute({
                params: { leadId: lead.id },
                to: '/leads/details/$leadId',
            })
            .catch((err) => {
                Sentry.captureException(err);
            });
    };

    return (
        <tr
            data-testid="search-result"
            onMouseEnter={preload}
            onClick={() => window.open(`/leads/details/${lead.id}`, '_blank')}
            className={cn(
                'cursor-pointer group/row hover:bg-grey-dark duration-150',
                brightness === 'dark' ? 'bg-surface-light' : 'bg-white',
            )}
        >
            <td>
                <ContactInfo lead={safeLeadData} />
            </td>
            <td>
                <StatusInfo lead={safeLeadData} />
            </td>
            <td>
                <LeadInfo lead={safeLeadData} />
            </td>
            <td>
                <LeadTraitInfo lead={safeLeadData} />
            </td>
            <td>
                <TableColumnAdviserAssign lead={safeLeadData} />
            </td>
        </tr>
    );
};
